<template>
    <div class="input-picker-wrapper" v-click-outside="hideInputPicker">
        <div class="input-picker" @click="clickInputPicker" :class="{'input-picker-showing': showPicker, 'picked': dateAux}">
            <img src="/img/iconos/bp-seleccion-date.svg" alt="bp-seleccion-date.svg" class="icon">
            <template v-if="!dateAux">
                Selecciona la fecha de entrega
            </template>
            <template v-else>
                {{ dateFormatted }}
            </template>
        </div>
        <div v-if="value || dateAux || showPicker" v-show="showPicker" class="input-picker-show">
            <h4 class="c-question c-question-first">¿En qué semana deseas recibir la planta?</h4>
            <p>
                La fecha de entrega es necesaria para escoger la mejor selección
            </p>
            <div class="c-datepicker-wrapper">
                <custom-date-picker v-model="dateAux" @selected="selectedDate" :block-to="blockTo"></custom-date-picker>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import CustomDatePicker from "./CustomDatePicker";
export default {
    name: "BpSeleccionDate",
    components: {CustomDatePicker},
    props: {
        value: {},
        blockTo: {
            type: Date,
            default: () => moment().toDate()
        }
    },
    data() {
        return {
            showPicker: false,
            dateAux: null
        }
    },
    computed: {
        dateFormatted() {
            let dateFormatted = null;
            if (this.dateAux) {
                dateFormatted = moment(this.dateAux).format('LL')
            }
            return dateFormatted;
        },
    },
    watch: {
        value(val) {
            this.dateAux = val;
        },
        dateAux(val) {
            this.$emit('input', val);
            this.$emit('changed', val);
        }
    },
    methods: {
        clickInputPicker() {
            this.showPicker = !this.showPicker;
        },
        hideInputPicker() {
            this.showPicker = false;
        },
        selectedDate() {
            this.$nextTick(() => {
                this.hideInputPicker();
            })
        }
    },
    created() {
        this.dateAux = this.value;
    },
    directives: {
        clickOutside: vClickOutside.directive
    }
}
</script>

<style scoped>
    .input-picker-wrapper {
        position: relative;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }

    .input-picker {
        font-weight: bold;
        padding: 0.5rem;
        border: 3px solid #ffc82f;
        width: fit-content;
        margin: auto;
        cursor: pointer;
        font-size: 1.2em;
    }

    .input-picker.input-picker-showing {
        border-bottom: 0;
        background: #ffc82f;
    }

    .input-picker.picked {
        background: #ffc82f;
    }

    .input-picker:hover {
        background: #ffd172;
    }

    .icon {
        width: 1.5em;
    }

    .input-picker-show {
        width: auto;
        position: absolute;
        background: #ffffff;
        z-index: 999;
        padding: 1rem 0.3rem 1rem 0.3rem;
        border: 3px solid #ffc82f;
        border-radius: 4px;
    }
</style>
